var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { CustomReportPageView } from "./ui/CustomReportPageView";
import { useApiPostReports } from "../../fnx/reports/postReports";
import { showErrorToast } from "../../fnx/showError";
import { useDispatch, useSelector } from "react-redux";
import { typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { useNavigate } from "react-router-dom";
import { AlertLoadingHeader } from "../../components/alertLoadingComponent/alertLoading";
import showToast from "../../services/toast";
import { quoteAll, quoteAllClearData } from "../../store/generateQuote/actions";
import { getCurrentMonth, getCurrentSemester, getPreviousMonth, getQuarterDates, } from "../../services/getDates";
import { formattedDateWithTime } from "../../utils/date";
import useUpdateData from "./helpers/reporData";
import { reportsClearData } from "../../store/reports/actions";
import { getQuoteList } from "../../utils/normalizeQuoteResponse";
export var CustomReportPage = function () {
    var t = useTranslation().t;
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var _a = useState({
        enable: true,
        page: 1,
        limit: 5000,
        reportCard: [],
        reportTrigger: false,
        bodyReport: { page: 0, pageSize: 10 },
        dateRange: "",
    }), state = _a[0], setState = _a[1];
    var _b = useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), toast = _b[0], setToast = _b[1];
    var _c = useUpdateData(t), newDownData = _c.newDownData, dataSeries = _c.dataSeries, dataCategories = _c.dataCategories, updateData = _c.updateData;
    //CALL APIS
    var _d = useApiPostReports(state.reportTrigger, state.bodyReport), loadingReports = _d.loadingReports, responseReports = _d.responseReports, errorReports = _d.errorReports;
    var _e = useSelector(function (state) { return ({
        responseAllQuote: state.Quote.responseAllQuote,
        errorAllQuote: state.Quote.errorAllQuote,
        loadingAllQuote: state.Quote.loadingAllQuote,
    }); }), responseAllQuote = _e.responseAllQuote, errorAllQuote = _e.errorAllQuote, loadingAllQuote = _e.loadingAllQuote;
    //END CALL APIS
    useEffect(function () {
        setState(function (prev) { return (__assign(__assign({}, prev), { reportTrigger: true })); });
        var _a = getCurrentMonth(), startDate = _a.startDate, endDate = _a.endDate;
        callQuoteAll(startDate, endDate);
        setState(function (prev) { return (__assign(__assign({}, prev), { dateRange: "currentMonth" })); });
    }, []);
    useEffect(function () {
        if (errorReports) {
            showErrorToast(errorReports, setToast, t);
            setState(function (prev) { return (__assign(__assign({}, prev), { reportTrigger: false })); });
            dispatch(reportsClearData());
        }
    }, [errorReports]);
    useEffect(function () {
        if (errorAllQuote) {
            showErrorToast(errorAllQuote, setToast, t);
            dispatch(quoteAllClearData());
        }
    }, [errorAllQuote]);
    useEffect(function () {
        if (responseReports) {
            var data_1 = responseReports.map(function (item) { return ({
                id: item.id,
                title: item.name,
                subTitle: "Por Rango de fechas",
            }); });
            setState(function (prev) { return (__assign(__assign({}, prev), { reportCard: data_1 })); });
            dispatch(reportsClearData());
        }
    }, [responseReports]);
    useEffect(function () {
        var quoteList = getQuoteList(responseAllQuote);
        if (quoteList.length > 0) {
            updateData(quoteList);
            dispatch(quoteAllClearData());
        }
    }, [responseAllQuote]);
    var onClickMonthReport = function (item) {
        var _a, _b, _c, _d, _e;
        var startDate, endDate;
        switch (item.code) {
            case "currentMonth":
                (_a = getCurrentMonth(), startDate = _a.startDate, endDate = _a.endDate);
                callQuoteAll(startDate, endDate);
                setState(function (prev) { return (__assign(__assign({}, prev), { dateRange: "currentMonth" })); });
                break;
            case "prevMonth":
                (_b = getPreviousMonth(), startDate = _b.startDate, endDate = _b.endDate);
                callQuoteAll(startDate, endDate);
                setState(function (prev) { return (__assign(__assign({}, prev), { dateRange: "prevMonth" })); });
                break;
            case "currentQuarter":
                (_c = getQuarterDates("current"), startDate = _c.startDate, endDate = _c.endDate);
                callQuoteAll(startDate, endDate);
                setState(function (prev) { return (__assign(__assign({}, prev), { dateRange: "currentQuarter" })); });
                break;
            case "prevQuarter":
                (_d = getQuarterDates("previous"), startDate = _d.startDate, endDate = _d.endDate);
                callQuoteAll(startDate, endDate);
                setState(function (prev) { return (__assign(__assign({}, prev), { dateRange: "prevQuarter" })); });
                break;
            case "currentSemester":
                (_e = getCurrentSemester(), startDate = _e.startDate, endDate = _e.endDate);
                callQuoteAll(startDate, endDate);
                setState(function (prev) { return (__assign(__assign({}, prev), { dateRange: "currentSemester" })); });
                break;
        }
    };
    var openReport = function (action, item) {
        if (action.name === "Previsualizar") {
            navigate("/reports-sumamaries/".concat(item.id, "/").concat(state.dateRange));
        }
    };
    var filterCalendar = function (dates) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var startDate = formattedDateWithTime((_a = dates === null || dates === void 0 ? void 0 : dates.dateRange) === null || _a === void 0 ? void 0 : _a.startDate) === "undefined" ||
            formattedDateWithTime((_b = dates === null || dates === void 0 ? void 0 : dates.dateRange) === null || _b === void 0 ? void 0 : _b.startDate) === "null" ||
            formattedDateWithTime((_c = dates === null || dates === void 0 ? void 0 : dates.dateRange) === null || _c === void 0 ? void 0 : _c.startDate) === "NA"
            ? ""
            : formattedDateWithTime((_d = dates === null || dates === void 0 ? void 0 : dates.dateRange) === null || _d === void 0 ? void 0 : _d.startDate);
        var endDate = formattedDateWithTime((_e = dates === null || dates === void 0 ? void 0 : dates.dateRange) === null || _e === void 0 ? void 0 : _e.endDate) === "undefined" ||
            formattedDateWithTime((_f = dates === null || dates === void 0 ? void 0 : dates.dateRange) === null || _f === void 0 ? void 0 : _f.endDate) === "null" ||
            formattedDateWithTime((_g = dates === null || dates === void 0 ? void 0 : dates.dateRange) === null || _g === void 0 ? void 0 : _g.endDate) === "NA"
            ? ""
            : formattedDateWithTime((_h = dates === null || dates === void 0 ? void 0 : dates.dateRange) === null || _h === void 0 ? void 0 : _h.endDate);
        callQuoteAll(startDate, endDate);
    };
    var clearCalendar = function () {
        var _a = getCurrentMonth(), startDate = _a.startDate, endDate = _a.endDate;
        callQuoteAll(startDate, endDate);
    };
    var callQuoteAll = function (date1, date2) {
        dispatch(quoteAll({
            enable: state.enable,
            creationDateStart: date1,
            creationDateEnd: date2,
            page: state.page,
            limit: state.limit,
        }));
    };
    return (_jsxs(_Fragment, { children: [_jsx(AlertLoadingHeader, { loading: loadingReports || loadingAllQuote, seeToast: toast, showToast: showToast, setSeeToast: setToast, titleLoading: t("salesReport.loading") }), _jsx(CustomReportPageView, { Tl: t, reportCard: state.reportCard, openReport: openReport, newDownData: newDownData, onClickMonthReport: onClickMonthReport, dataSeries: dataSeries, dataCategories: dataCategories, filterCalendar: filterCalendar, clearCalendar: clearCalendar })] }));
};
